import { Component, OnInit,ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MasterService } from '../masters/master.service';
import { DynamicFormService } from '../dynamic-form-builder/dynamic-form-service';
import { ToastrService } from 'ngx-toastr';
import * as CommonConstants from 'src/app/utils/common.constants';
import { AddPractitionerComponent } from '../partners/practitioners/add-practitioner/add-practitioner.component';
@Component({
  selector: 'app-myspace-practitionar',
  templateUrl: './myspace-practitionar.component.html',
  styleUrls: ['./myspace-practitionar.component.scss']
})
export class MyspacePractitionarComponent implements OnInit {
  fieldsPracitce: any[] = [];
  fieldsProScienPubli: any[] = [];
  fieldsProScienSoci: any[] = [];
  fieldsProfessinalSpecialities: any[] = [];
  fieldsHospital: any[] = [];
  fieldsMyActivities: any[] = [];
  fieldsQuality: any[] = [];
  fieldsActivityCost: any[] = [];
  fieldsMyEstimates: any[] = [];
  fieldsMyBills: any[] = [];

  //Transactional List
  listPracitce: any[] = [];
  listProScienPubli: any[] = [];
  listProScienSoci: any[] = [];
  listProfessinalSpecialities: any[] = [];
  listHospital: any[] = [];
  listMyActivities: any[] = [];
  listQuality: any[] = [];
  listActivityCost: any[] = [];
  listMyEstimates: any[] = [];
  listMyBills: any[] = [];

  partnerId=+localStorage.getItem(CommonConstants.PARTNER_ID);
  partnerType=+localStorage.getItem(CommonConstants.PARTNER_TYPE);
  rowId=1;
  @ViewChild(AddPractitionerComponent, { static: true }) practionar: AddPractitionerComponent;
  ngOnInit() {
    this.practionar.loadPractitionerById(this.partnerId);
    this.masterService.getMasterForms(1).subscribe(response => {
      if (response && response['result']) {
        this.fieldsHospital = response['result'];
      }
    })
    this.masterService.getMasterForms(2).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProfessinalSpecialities = response['result'];
      }
    })
    this.masterService.getMasterForms(3).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProScienSoci = response['result'];
      }
    })
    this.masterService.getMasterForms(4).subscribe(response => {
      if (response && response['result']) {
        this.fieldsProScienPubli = response['result'];
      }
    })
    this.masterService.getMasterForms(6).subscribe(response => {
      if (response && response['result']) {
        this.fieldsMyActivities = response['result'];
      }
    })
    this.masterService.getMasterForms(7).subscribe(response => {
      if (response && response['result']) {
        this.fieldsQuality = response['result'];
      }
    })
    this.masterService.getMasterForms(8).subscribe(response => {
      if (response && response['result']) {
        this.fieldsActivityCost = response['result'];
      }
    })
    this.masterService.getMasterForms(9).subscribe(response => {
      if (response && response['result']) {
        this.fieldsMyEstimates = response['result'];
      }
    })
    this.masterService.getMasterForms(10).subscribe(response => {
      if (response && response['result']) {
        this.fieldsMyBills = response['result'];
      }
    })
    this.masterService.getMasterForms(5).subscribe(response => {
      if (response && response['result']) {
        this.fieldsPracitce = response['result'];
      }
    })
    // Transactional Data Fetch

    this.dynamicForm.getFormData(1,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listHospital = response['result'];
      }
    })

    this.dynamicForm.getFormData(2,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProfessinalSpecialities = response['result'];
      }
    })

    this.dynamicForm.getFormData(3,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProScienSoci = response['result'];
      }
    })

    this.dynamicForm.getFormData(4,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listProScienPubli = response['result'];
      }
    })

    this.dynamicForm.getFormData(5,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listPracitce = response['result'];
      }
    })
    this.dynamicForm.getFormData(6,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listMyActivities = response['result'];
      }
    })
    this.dynamicForm.getFormData(7,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listQuality = response['result'];
      }
    })
    this.dynamicForm.getFormData(8,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listActivityCost = response['result'];
      }
    })
    this.dynamicForm.getFormData(9,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listMyEstimates = response['result'];
      }
    })
    this.dynamicForm.getFormData(10,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.listMyBills = response['result'];
      }
    })
  }
  public form: FormGroup;
  unsubcribe: any

  public fields: any[] = [
    {
      type: 'text',
      name: 'firstName',
      label: 'First Name',
      value: '',
      required: true,
    },
    {
      type: 'text',
      name: 'lastName',
      label: 'Last Name',
      value: '',
      required: true,
    },
    {
      type: 'text',
      name: 'email',
      label: 'Email',
      value: '',
      required: true,
    },

    {
      type: 'dropdown',
      name: 'country',
      label: 'Country',
      value: 'in',
      required: true,
      options: [
        { key: 'in', label: 'India' },
        { key: 'us', label: 'USA' }
      ]
    },
   
  ];
  public rowData: any[] = [];
  constructor(private masterService:MasterService,private dynamicForm:DynamicFormService,private toastrService:ToastrService) {
    this.form = new FormGroup({
      fields: new FormControl(JSON.stringify(this.fields))
    })
    this.unsubcribe = this.form.valueChanges.subscribe((update) => {
      //console.log(update);
      this.fields = JSON.parse(update.fields);
    });
  }
save(event,formId){
  //First Get The row id
  this.dynamicForm.getMaxRowId(formId,this.partnerId,this.partnerType).subscribe(response => {
    if (response && response['result']) {
      this.rowId = response['result'];
      this.rowId=this.rowId+1;
    }
    let formData=[];
    Object.keys(event).forEach(name => {
      let keyValue=this.fields.filter(item => item.name===name)[0].key;
      let obj={};
      obj["formId"]=formId;
      obj["key"]=keyValue;
      obj["value"]=event[name];
      obj["rowId"]=this.rowId;
      obj["partnerId"]=this.partnerId;
      obj["partnerType"]=this.partnerType;
     // obj["runId"]=1;
      obj["keyName"]=name;
      formData.push(obj);
    });
    //console.log(JSON.stringify(formData));
    this.dynamicForm.saveFormData(formData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        
      }
    })
  
  })
  
}
  onUpload(e) {
    console.log(e);

  }

  getFieldsHospital() {
    this.fields=this.fieldsHospital;
    return this.fieldsHospital;
  }
  getFieldsProfesScientific() {
    this.fields=this.fieldsProScienSoci;
    return this.fieldsProScienSoci;
  }
  getFieldsProfSpecilities() {
    this.fields=this.fieldsProfessinalSpecialities;
    return this.fieldsProfessinalSpecialities;
  }
  getFieldsScientificPublic() {
    this.fields=this.fieldsProScienPubli;
    return this.fieldsProScienPubli;
  }
  getFieldsPractice() {
    this.fields=this.fieldsPracitce;
    return this.fieldsPracitce;
  }
  getFieldsActivities() {
    this.fields=this.fieldsMyActivities;
    return this.fieldsMyActivities;
  }
  getFieldsQuality() {
    this.fields=this.fieldsQuality;
    return this.fieldsQuality;
  }
  getFieldsActivityCost() {
    this.fields=this.fieldsActivityCost;
    return this.fieldsActivityCost;
  }
  getFieldsEstimates() {
    this.fields=this.fieldsMyEstimates;
    return this.fieldsMyEstimates;
  }
  getFieldsBills() {
    this.fields=this.fieldsMyBills;
    return this.fieldsMyBills;
  }


  ngDistroy() {
    this.unsubcribe();
  }
  setForm(){
    console.log("yes we can do it")
  }
  getListHospital(){
    return this.listHospital;
  }
  getListProfSpecilities(){
    return this.listProfessinalSpecialities;
  }
  getListProfesScientific(){
    return this.listProScienSoci;
  }
  getListScientificPublic(){
    return this.listProScienPubli;
  }
  getListPractice(){
    return this.listPracitce;
  }
  getListActivities(){
    return this.listMyActivities;
  }
  getListQuality(){
    return this.listQuality;
  }
  getListActivityCost(){
    return this.listActivityCost;
  }
  getListEstimates(){
    return this.listMyEstimates;
  }
  getListBills(){
    return this.listMyBills;
  }
 
  getFields(formId){
    this.masterService.getMasterForms(formId).subscribe(response => {
      if (response && response['result']) {
        this.fields = response['result'];
        return this.fields;
      }
    })
    return this.fields;
  }
  getRowData(formId){
    this.dynamicForm.getFormData(formId,this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.rowData = response['result'];
        return this.rowData;
      }
    })
    return this.rowData;
  }
}
